export default __webpack_public_path__ + "static/media/thumb-GNSS-Antenna-6.d05d1476.png";